const angular = require('angular');

const CategoriesService = require('./categories.service');
const wowCategorySref = require('./category-sref.directive');

angular.module('wowApp.shop')
    .service('CategoriesService', CategoriesService)
    .directive('wowCategorySref', ['$state', '$timeout', 'CategoriesService', wowCategorySref])
    .component('wowCategoriesNavigation', require('./categories-navigation.component').categoriesNavigationComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/categories/index.js